import React from 'react';
import { Box, Card, Checkbox, Input, Text } from '@nimbus-ds/components';

function AmountCardSkeleton(): JSX.Element {
  return (
    <Card padding="none" data-testid="WithdrawAmountForm-AmountCard-Skeleton">
      <Card.Body padding="none">
        <Box display="grid" margin="4" gap="5">
          <Box display="grid" gap="2" marginBottom="1">
            <Text.Skeleton width="40px" height="18px" />
            <Input.Skeleton width="100%" />
          </Box>
          <Checkbox.Skeleton width="40px" />
        </Box>
      </Card.Body>
    </Card>
  );
}

export default AmountCardSkeleton;
